"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractPredicateBuilder = void 0;
class AbstractPredicateBuilder {
    constructor(facade) {
        this.facade = facade;
    }
}
exports.AbstractPredicateBuilder = AbstractPredicateBuilder;
//# sourceMappingURL=abstract-predicate-builder.js.map